var map = {
	"./about-us.svg": 756,
	"./betting-icon.svg": 757,
	"./bonus.svg": 758,
	"./coin.svg": 759,
	"./contact-us.svg": 760,
	"./download-app.svg": 761,
	"./edit-btn.svg": 762,
	"./feedback.svg": 763,
	"./global.svg": 764,
	"./info-centre.svg": 765,
	"./info-centre.webp": 1642,
	"./instant-rebate.svg": 766,
	"./mall-icon.svg": 767,
	"./message.svg": 768,
	"./personal-info-edit.svg": 769,
	"./r77-coin.svg": 770,
	"./r77-rewards.svg": 771,
	"./redemption-icon.svg": 772,
	"./referral.svg": 773,
	"./resp-gaming.svg": 774,
	"./security.svg": 775,
	"./transaction-icon.svg": 776,
	"./vip-icon.svg": 777,
	"./wallet-icon.svg": 778
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 755;